import React, { useEffect, useState } from "react";
import UserImg from "../../../../assets/images/profile-avatar.webp";
import { Avatar } from "primereact/avatar";
import PrimaryButton from "../../../../shared/components/CustomButtons";
import { Dialog } from "primereact/dialog";
import {
  CustomCalander,
  CustomInput,
  CustomPassword,
} from "../../../../shared/components/AllInputs";
import { isAuthenticated } from "../../../../shared/services/auth";
import { getProfileAction } from "../../../../store/actions/user.actions";
import { useDispatch, useSelector } from "react-redux";
import formValidation from "../../../../utils/validations";
import {
  changeUserPassword,
  updateUserProfile,
} from "../../../../store/slices/userSlice";
import { getImageUrl, showFormErrors } from "../../../../utils/commonFunctions";
import moment from "moment";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

export default function Profile() {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user);
  const [profileData, setProfileData] = useState();
  const [changePasswordData, setChangePasswordData] = useState({
    password: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showEditProfileDialog, setShowEditProfileDialog] = useState(false);
  const [showChangePasswordDialog, setShowChangePasswordDialog] =
    useState(false);

  useEffect(() => {
    if (isAuthenticated() && !profile) dispatch(getProfileAction());
  }, [dispatch]);

  const handleChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, profileData);
    setProfileData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handlePasswordChange = ({ name, value }) => {
    const formErrors = formValidation(name, value, changePasswordData);
    setChangePasswordData((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const updateProfile = () => {
    dispatch(
      updateUserProfile({
        data: profileData,
        setVisible: setShowEditProfileDialog,
      })
    );
  };

  const changePassword = () => {

    if (showFormErrors(changePasswordData, setChangePasswordData)) {
      dispatch(
        changeUserPassword({
          data: changePasswordData,
          setVisible: setShowChangePasswordDialog,
        })
      );
    }
  };

  return (
    <div className="container">
      <div className="md:flex justify-content-between gap-3">
        <h2 className="text-3xl">Profile</h2>
      </div>
      <hr />
      <div className="profile-container p-5 mt-4 border-round-lg">
        <div className="grid justify-content-between">
          <div className="md:col-7">
            <Avatar
              image={profile?.image ? getImageUrl(profile?.image) : UserImg}
              name="image"
              size="xlarge"
              shape="circle"
            />
            <div className="grid">
              <div className="col-12 lg:col-4">
                <p className="font-bold my-2">Name</p>
                <p className="text-gray-color m-0">{profile?.fullName}</p>
              </div>
              <div className="col-12 lg:col-4">
                <p className="font-bold my-2">Email</p>
                <p className="text-gray-color m-0">{profile?.email}</p>
              </div>
              <div className="col-12 lg:col-4">
                <p className="font-bold my-2">Phone number</p>
                <p className="text-gray-color m-0">{profile?.mobile}</p>
              </div>
              <div className="col-12 lg:col-4">
                <p className="font-bold my-2">Date of Birth</p>
                <p className="text-gray-color m-0">
                  {moment(profile?.dob).format("DD MMM, YYYY")}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 md:col-5 flex flex-column lg:flex-row h-full justify-content-end gap-3 align-items-start">
            <PrimaryButton
              label="Edit Profile"
              extraClassNames="bg-gray-600 w-full lg:w-5"
              icon="pi pi-pencil"
              onClick={() => {
                setProfileData({
                  fullName: profile?.fullName,
                  email: profile?.email,
                  dob: new Date(profile?.dob) || "",
                  image: profile?.image || "",
                  mobile: profile?.mobile || "",
                });
                setShowEditProfileDialog(true);
              }}
            />
            <PrimaryButton
              label="Change Password "
              extraClassNames="bg-gray-600 w-full lg:w-5"
              onClick={setShowChangePasswordDialog}
            />
          </div>
        </div>
      </div>
      <Dialog
        header="Edit Profile"
        closable={false}
        headerClassName="bg-red text-center text-white"
        visible={showEditProfileDialog}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "95vw" }}
        draggable={false}
        resizable={false}
      >
        <div className="mt-4">
          <div className="profile-photo">
            <img
              src={
                profileData?.image ? getImageUrl(profileData?.image) : UserImg
              }
              alt=""
            />
            <div className="upload-img">
              <input
                name="image"
                type="file"
                accept=".jpg, .jpeg, .png"
                onChange={(e) =>
                  handleChange({ name: "image", value: e.target.files[0] })
                }
              />
              <i className="pi pi-camera"></i>
            </div>
          </div>
          <div className="mt-3">
            <CustomInput
              label="Name"
              name="fullName"
              data={profileData}
              placeholder="Email"
              col={12}
              onChange={handleChange}
            />
            <CustomInput
              label="Email"
              name="email"
              data={profileData}
              disabled
              placeholder="Email"
              col={12}
            />
            <PhoneInput
              name="mobile"
              inputClass="w-full"
              country={"us"}
              value={profileData?.mobile}
              onChange={(value, country, e, formattedValue) =>
                handleChange({ name: "mobile", value: formattedValue })
              }
            />
            <CustomCalander
              label="Date of Birth"
              col={12}
              className="w-full"
              name="dob"
              data={profileData}
              onChange={handleChange}
            />
          </div>
          <div className="mt-4 flex flex-column md:flex-row gap-3">
            <PrimaryButton
              label="Save changes"
              extraClassNames="w-full md:w-6"
              onClick={updateProfile}
            />
            <PrimaryButton
              label="Cancel"
              extraClassNames="bg-gray-400 w-full md:w-6"
              onClick={() => {
                if (!showEditProfileDialog) return;
                setShowEditProfileDialog(false);
              }}
            />
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Change Password"
        closable={false}
        headerClassName="bg-red text-center text-white"
        visible={showChangePasswordDialog}
        style={{ width: "30vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
        draggable={false}
        resizable={false}
      >
        <div className="mt-4">
          <div className="mt-3">
            <CustomPassword
              label="Old Password"
              name="password"
              placeholder="Password"
              col={12}
              data={changePasswordData}
              onChange={handlePasswordChange}
            />
            <CustomPassword
              label="New Password"
              name="newPassword"
              placeholder="New password"
              col={12}
              data={changePasswordData}
              onChange={handlePasswordChange}
            />
            <CustomPassword
              label="Confirm Password"
              name="confirmNewPassword"
              placeholder="Confirm password"
              col={12}
              data={changePasswordData}
              onChange={handlePasswordChange}
            />
          </div>
          <div className="mt-4 flex gap-3">
            <PrimaryButton
              label="Save changes"
              extraClassNames="w-6"
              onClick={changePassword}
            />
            <PrimaryButton
              label="Cancel"
              extraClassNames="bg-gray-400 w-6"
              onClick={() => {
                setShowChangePasswordDialog(false);
              }}
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
